import { KeyboardEvent } from 'react';

export interface Shortcut {
  id: string;
  key: string;
  description: string;
  modifier?: 'shift' | 'ctrl' | 'alt';
  category: 'playback' | 'navigation' | 'volume' | 'haptics' | 'library';
  condition?: string;
}

export const shortcuts: Shortcut[] = [
  {
    id: 'toggle-play',
    key: 'Space',
    description: 'Play or pause the current track',
    category: 'playback'
  },
  {
    id: 'seek-forward',
    key: 'ArrowRight',
    modifier: 'shift',
    description: 'Seek forward 10 seconds',
    category: 'playback',
    condition: 'When a track is loaded'
  },
  {
    id: 'seek-backward',
    key: 'ArrowLeft',
    modifier: 'shift',
    description: 'Seek backward 10 seconds',
    category: 'playback',
    condition: 'When a track is loaded'
  },
  {
    id: 'next-track',
    key: 'ArrowRight',
    description: 'Play next track',
    category: 'playback'
  },
  {
    id: 'previous-track',
    key: 'ArrowLeft',
    description: 'Play previous track',
    category: 'playback'
  },
  {
    id: 'volume-up',
    key: 'ArrowUp',
    modifier: 'shift',
    description: 'Increase volume by 10%',
    category: 'volume'
  },
  {
    id: 'volume-down',
    key: 'ArrowDown',
    modifier: 'shift',
    description: 'Decrease volume by 10%',
    category: 'volume'
  },
  {
    id: 'toggle-loop',
    key: 'KeyL',
    description: 'Toggle loop mode (Off → One → All)',
    category: 'playback'
  },
  {
    id: 'toggle-haptics',
    key: 'KeyH',
    description: 'Toggle haptic feedback',
    category: 'haptics'
  },
  {
    id: 'toggle-like',
    key: 'KeyF',
    description: 'Toggle like status of current track',
    category: 'library',
    condition: 'When a track is loaded'
  }
];

export const getShortcutById = (id: string): Shortcut | undefined => {
  return shortcuts.find(shortcut => shortcut.id === id);
};

export const getShortcutByKey = (event: KeyboardEvent<Element>): Shortcut | undefined => {
  return shortcuts.find(
    shortcut => 
      shortcut.key === event.code && 
      (!shortcut.modifier || 
        (shortcut.modifier === 'shift' && event.shiftKey) ||
        (shortcut.modifier === 'ctrl' && event.ctrlKey) ||
        (shortcut.modifier === 'alt' && event.altKey)
      )
  );
};
